import React from "react";

const EmployeeCompetatives = () => {
    return <div>Employee Competatives</div>;
}

export default EmployeeCompetatives;